module.exports = __webpack_public_path__ + "static/media/45.095ad158.png";